import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';

import Payout from './pages/payout';

ReactDOM.render(
  <React.StrictMode>
    <Payout />
  </React.StrictMode>,
  document.getElementById('root')
);
